import { firePanelAction } from './firePanelAction';
import { TExternalActionDispatcher } from './usePanelActions';

export const externalFirePanelAction: TExternalActionDispatcher = (
  panelId,
  { action, ...parameters },
  options,
) => {
  const postData: Record<string, unknown> = {};

  Object.entries(parameters).forEach(([name, value]) => {
    postData[`p_${name}`] = value;
  });

  firePanelAction(panelId, action, postData, options);
};
